export interface ModelListConfig {
  filterPaneState: FilterPaneState
  rowClickBehavior: RowClickBehavior
  quickPreviewLocation: QuickPreviewLocation
  viewType: ViewType
}

export enum FilterPaneState {
  Closed = 'Closed',
  Open = 'Open',
}

export enum RowClickBehavior {
  Preview = 'Preview',
}

export enum QuickPreviewLocation {
  Right = 'Right',
}

export enum ViewType {
  Standard = 'Standard',
  Compact = 'Compact',
}
